import { urlBase } from "./config";
import axiosInstance from "../services/config/axiosinstance";

async function getUsersEvents(eventId) {
  var config = {
    method: "get",
    url: `${urlBase}/login-admin-eventos/${eventId}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function createUserEvents(data) {
  //
  var config = {
    method: "post",
    url: `${urlBase}/login-admin-eventos`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

export { getUsersEvents, createUserEvents };
